export { GoogleMapsMarker, type GoogleMapsMarkerProps } from './Marker';
